import type { TabsProps } from 'antd';
import type { Station } from '../../api/eventsService';
import { HistoricalWeatherTrend } from '../HistoricalWeatherTrend/HistoricalWeatherTrend';
import { SessionComparison } from '../SessionComparison/SessionComparison';

/** Optional context when analytics are shown outside a selected event (e.g. circuit picker page). */
export type ClimateRecapAnalyticsContext = {
  demo?: boolean;
  legacy?: boolean;
  stations?: Station[];
  circuitTimeZone?: string;
};

export function climateRecapAnalyticsTabItems(
  circuitId: string,
  ctx?: ClimateRecapAnalyticsContext
): NonNullable<TabsProps['items']> {
  return [
    {
      key: 'historical-weather',
      label: 'Historical Weather Trend',
      children: (
        <HistoricalWeatherTrend
          circuitId={circuitId}
          demo={ctx?.demo}
          legacy={ctx?.legacy}
          circuitTimeZone={ctx?.circuitTimeZone}
        />
      ),
    },
    {
      key: 'session-comparison',
      label: 'Compare Sessions',
      children: (
        <SessionComparison
          circuitId={circuitId}
          stations={ctx?.stations}
          circuitTimeZone={ctx?.circuitTimeZone}
          demo={ctx?.demo}
          legacy={ctx?.legacy}
        />
      ),
    },
  ];
}
